var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"action-symbol",class:{ 'is-danger': _vm.name === 'delete' && !_vm.inherit, inherit: _vm.inherit, dots: _vm.name === 'more' },attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},_vm._l((_vm.paths),function(path,index){return _c('path',{key:index,attrs:{"d":path}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }